export default __webpack_public_path__ + "static/assets/bb37e7fe791d79f80434ae26048f7571.png";